let dirPath = 'static/games/page006_game2';

let configGame = {
  removeInCorrects: true,
  correctBlock: false,
  //autoCheckAllCorrect: true,
  removeAllFromBadTarget: true,
  rulesGame: {
    itemsGarbage: [{ idGroup: 'source', itemsConfig: { block: false, shuffle: false } }],
    itemsConfig: {
      block: true,
    },
    otherProperty: {
      hideInTarget: true,
      // checkCorrectInRealTime: true,
      sounds: [
        // { src: dirPath + '/audio/good.mp3', id: 'correct' },
        // { src: dirPath + '/audio/bad.mp3', id: 'wrong' },
        { src: dirPath + '/audio/klik.mp3', id: 'mouseup' },
      ],
    },
    items: [
      {
        idGroup: 'mapa',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '13',
            correct: [{ idGroup: 'mapa', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '14',
            correct: [{ idGroup: 'mapa', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '15',
            correct: [{ idGroup: 'mapa', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '16',
            correct: [{ idGroup: 'mapa', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '17',
            correct: [{ idGroup: 'mapa', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '18',
            correct: [{ idGroup: 'mapa', idItem: 'legend' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { textAlign: 'center', bold: true },
      },
    },
    groups: [
      {
        idGroup: 'mapa',
        background: {
          color: 'transparent',
        },
        positions: {
          type: 'absolute',
          pos: { x: 1440, y: 30, height: 180, width: 180 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            background: {
              color: 'transparent',
              image: { src: dirPath + '/img/20.png', pos: { x: 0, y: 0, height: 180, width: 180 } },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        background: {
          color: 'transparent',
        },
        positions: {
          type: 'absolute',
          // pos: { x: 185, y: 0 },
          // autoFit: true,
        },
        // itemsConfig: {
        //   positions: {
        //     pos: { height: 170, width: 170 },
        //     // margin: { right: 10, top: 30 },
        //     // rows: 4,
        //   },
        // },
        items: [
          // {
          //   id: '05',
          //   background: {
          //     image: { src: dirPath + '/img/00.png' },
          //   },
          // },
          {
            id: '06',
            background: {
              image: { src: dirPath + '/img/01.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 200, y: 220, height: 170, width: 170 },
            },
          },
          {
            id: '07',
            background: {
              image: { src: dirPath + '/img/02.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 390, y: 30, height: 170, width: 170 },
            },
          },
          {
            id: '04',
            background: {
              image: { src: dirPath + '/img/03.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 200, y: 30, height: 170, width: 170 },
            },
          },
          {
            id: '03',
            background: {
              image: { src: dirPath + '/img/04.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 200, y: 600, height: 170, width: 170 },
            },
          },
          {
            id: '10',
            background: {
              image: { src: dirPath + '/img/05.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 770, y: 220, height: 170, width: 170 },
            },
          },
          {
            id: '11',
            background: {
              image: { src: dirPath + '/img/06.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 390, y: 600, height: 170, width: 170 },
            },
          },
          {
            id: '12',
            background: {
              image: { src: dirPath + '/img/07.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 390, y: 220, height: 170, width: 170 },
            },
          },
          {
            id: '13',
            background: {
              image: { src: dirPath + '/img/09.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 580, y: 220, height: 170, width: 170 },
            },
          },
          {
            id: '14',
            background: {
              image: { src: dirPath + '/img/10.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 580, y: 600, height: 170, width: 170 },
            },
          },
          {
            id: '15',
            background: {
              image: { src: dirPath + '/img/11.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 580, y: 30, height: 170, width: 170 },
            },
          },
          {
            id: '16',
            background: {
              image: { src: dirPath + '/img/12.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 580, y: 410, height: 170, width: 170 },
            },
          },
          {
            id: '17',
            background: {
              image: { src: dirPath + '/img/13.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 390, y: 410, height: 170, width: 170 },
            },
          },
          {
            id: '18',
            background: {
              image: { src: dirPath + '/img/14.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 770, y: 30, height: 170, width: 170 },
            },
          },
          {
            id: '19',
            background: {
              image: { src: dirPath + '/img/15.png' },
            },
            positions: {
              type: 'absolute',
              pos: { x: 200, y: 410, height: 170, width: 170 },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  //   realHeight: 790,
  //   realWidth: 1820,
  mainImage: {
    imagePath: dirPath + '/img/bcg.png',
    pos: {
      y: 139,
      x: 190,
    },
    width: 1534,
  },

  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
